import { render } from "./AlertBoxItem.vue?vue&type=template&id=ed418ba4&ts=true"
import script from "./AlertBoxItem.vue?vue&type=script&lang=ts"
export * from "./AlertBoxItem.vue?vue&type=script&lang=ts"

import "./AlertBoxItem.vue?vue&type=style&index=0&id=ed418ba4&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__